// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__UEGtA","fileBtn":"File_fileBtn__1L0N0","closeBtn":"File_closeBtn__Wj4am","fileSelected":"File_fileSelected__Fuygq","disabled":"File_disabled__3ezZn"};